import React from 'react'
import { Button, Modal } from 'antd'
import { useNavigate } from 'react-router-dom'

const TrialSucessModal = ({trialSuccessModal, setTrialSuccessModal}) => {
    const navigate = useNavigate();
    return (
        <Modal
        title="Success" 
        open={trialSuccessModal} 
        onCancel={() => setTrialSuccessModal(false)}
        footer={null}
        >
        <p>Trial started successfully</p>
            <div className='d-flex justify-content-center'>
                <Button type="primary" onClick={() => navigate('/home')}>Go to Home</Button>
            </div>
        </Modal>
    )
}

export default TrialSucessModal
